<template>
	<div>
		<el-row :gutter="10">
		  <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4" :offset="2">
			  <div class="grid-content bg-purple left">
				  <div class="left-head">
					  <span>会员信息管理</span>
				  </div>
				  <router-link class="left-list" to="/usercenter/myinfo">
					  <span>我的信息</span>
				  </router-link>
				  <router-link class="left-list" to="/usercenter/resetpwd">
					 <span>修改密码</span>
				  </router-link>
				  <div class="left-list" @click="logout">
					  <span>退出系统</span>
				  </div>
				  <div class="left-head">
					  <span>招标信息管理</span>
				  </div>
				  <router-link class="left-list" to="/usercenter/pubzb">
					  <span>发布招标</span>
				  </router-link>
				  <router-link class="left-list" to="/usercenter/managezb">
					  <span>管理招标</span>
				  </router-link>
			  </div>
			  </el-col>
		  <el-col :xs="0" :sm="16" :md="16" :lg="16" :xl="16">
			  <div class="grid-content right">
				<router-view></router-view>
			  </div>
			  </el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row>
		 <el-col :xs="6" :sm="0" :md="0" :lg="0" :xl="0">
			 <div>
				<router-link class="mobile-left-list" to="/usercenter/myinfo" style="text-align: center;">
					<span>信息</span>
				</router-link> 
			 </div>
		 </el-col>
		 <el-col :xs="6" :sm="0" :md="0" :lg="0" :xl="0">
			 <router-link class="mobile-left-list" to="/usercenter/resetpwd" style="text-align: center;">
					<span>改密</span>
			 </router-link>
		 </el-col>
		 <el-col :xs="6" :sm="0" :md="0" :lg="0" :xl="0">
			 <router-link class="mobile-left-list" to="/usercenter/pubzb" style="text-align: center;">
					<span>发布</span>
			 </router-link>
		 </el-col>
		 <el-col :xs="6" :sm="0" :md="0" :lg="0" :xl="0">
			 <router-link class="mobile-left-list" to="/usercenter/managezb" style="text-align: center;">
				  <span>管理</span>
			 </router-link>
		 </el-col>
		</el-row>
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			  <div class="grid-content right">
				<router-view></router-view>
			  </div>
			  </el-col>
		</el-row>
	</div>

</template>

<script>
	export default{
		props:['myinfo','managezb','pubzb','resetpwd'],
		metaInfo() {
		  return {
			title: '会员中心 - ' + this.metaName,
			meta: [
			  { charset: "utf-8" },
			  { name: "keywords", content: this.metaKeywords },
			  { name: "description", content: this.metaDecs },
			],
		  };
		},
		data(){
			return{
				metaName: "",
				metaKeywords: "",
				metaDecs: "",
			}
		},
		mounted() {
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			})
			if(!window.localStorage.getItem('token')){
				this.$message({
					message:'请先登录！',
					type:'error'
				})
				this.$router.push('/login')
			}
		},
		methods:{
			logout(){
				window.localStorage.removeItem('token')
				this.$router.push('/')
				window.location.reload()
			}
		}
	}
</script>

<style scoped>
	.left-head{
		width:100%;
		height:50px;
		background-color: #409EFF;
		color:#fff;
		line-height: 50px;
		font-size: 1.2rem;
	}
	.left-head span{
		padding-left: 10px;
	}
	.left-list{
		display: block;
		cursor: pointer;
		color: #409EFF;
		width:100%;
		height:40px;
		line-height: 40px;
		font-size: 1rem;
		border-bottom: #fff 1px dashed;
		text-decoration: none;
	}
	.left-list span{
		padding-left: 10px;
	}
	.mobile-left-list{
		display: block;
		text-decoration: none;
		background: #409EFF;
		width:100%;
		height: 40px;
		line-height: 40px;
	}
	.mobile-left-list span{
		color:#fff;
		padding:12%;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
</style>